import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { formatDate } from 'date-fns'
import { UseFormSetError } from 'react-hook-form'
import { toast } from 'sonner'

export default function useDeleteMoneyPath({ id }: { id: number | string }) {
  const queryClient = useQueryClient()

  const action = async () => {
    const response = await httpClient.delete(`team/money-paths/${id}`)
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Money Path deleted.')
      queryClient.invalidateQueries({ queryKey: ['money-paths'] })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
    },
    onError: (e) => {
      toast.error(e.message ?? 'An error occurred.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
